import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavoritesContext = createContext(null);
const KEY = "str_hearted";
const EMAIL_KEY = "str_alert_email";
const readLocal = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const isBuyer = !!(user && user.role === "buyer");
  const [localIds, setLocalIds] = useState(readLocal);
  const [serverIds, setServerIds] = useState([]);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(localIds)); }, [localIds]);

  useEffect(() => {
    if (!isBuyer) return;
    let cancelled = false;
    (async () => {
      const local = readLocal();
      if (local.length) {
        try { await api.post("/favorites/merge", { product_ids: local }); localStorage.setItem(KEY, "[]"); setLocalIds([]); } catch (e) {}
      }
      try {
        const { data } = await api.get("/favorites");
        if (!cancelled) setServerIds(data.map((p) => p.id));
      } catch (e) { /* noop */ }
    })();
    return () => { cancelled = true; };
  }, [isBuyer]);

  const ids = isBuyer ? serverIds : localIds;

  const isFavorite = (id) => ids.includes(id);

  const addFavorite = (id) => {
    if (isBuyer) {
      setServerIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
      api.post(`/favorites/${id}`).catch(() => {});
    } else {
      setLocalIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
    }
  };

  const removeFavorite = (id) => {
    if (isBuyer) {
      setServerIds((prev) => prev.filter((x) => x !== id));
      api.delete(`/favorites/${id}`).catch(() => {});
    } else {
      setLocalIds((prev) => prev.filter((x) => x !== id));
    }
  };

  const getAlertEmail = () => (isBuyer && user?.email) ? user.email : (localStorage.getItem(EMAIL_KEY) || "");

  return (
    <FavoritesContext.Provider value={{ ids, isFavorite, addFavorite, removeFavorite, count: ids.length, getAlertEmail, isBuyer }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);
